import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-custom-header',
  templateUrl: './app-custom-header.component.html',
  styleUrls: ['./app-custom-header.component.scss']
})
export class AppCustomHeaderComponent implements OnInit {

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
  }

  openNewTab() {
    window.open('https://qwikkit.com/', '_blank');
  }

  signIn() {
    this.router.navigate(['/login']);
  }
}
